import type { UploadItemStatus } from './upload-progress.types';

export function formatUploadSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function uploadStatusLabel(s: UploadItemStatus): string {
  switch (s) {
    case 'pending':
      return 'Pendiente';
    case 'uploading':
      return 'Subiendo';
    case 'completed':
      return 'Completado';
    case 'error':
      return 'Error';
  }
}
